// =============================================================================
//  SCREEN: ClubScreen
// =============================================================================
//  Zweck: Hauptansicht für die Verwaltung von Vereinen.
//         Holt Daten vom Backend und ermöglicht das Erstellen, Bearbeiten
//         und Löschen von Vereinen.
// =============================================================================
import React, { useState, useEffect } from 'react';
import apiClient from '../api'; // GEÄNDERT: axios durch apiClient ersetzt
import ClubList from '../components/ClubList';

const ClubScreen = () => {
  // State für die Liste aller Vereine
  const [clubs, setClubs] = useState([]);
  
  // State für das aktuell zu bearbeitende Vereinsobjekt
  const [editingClub, setEditingClub] = useState(null); 
  
  // State für die Eingabefelder des Formulars
  const [name, setName] = useState('');
  const [contactPerson, setContactPerson] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  
  // State für Fehlermeldungen
  const [error, setError] = useState('');

  useEffect(() => {
    fetchClubs();
  }, []);

  const fetchClubs = async () => {
    try {
      const { data } = await apiClient.get('/api/clubs'); // GEÄNDERT: axios durch apiClient ersetzt
      setClubs(data);
    } catch (err) {
      setError('Fehler beim Laden der Vereine.');
    }
  };

  // Setzt das Formular zurück
  const resetForm = () => {
    setEditingClub(null);
    setName('');
    setContactPerson('');
    setEmail('');
    setPhone('');
    setError('');
  };

  // Wird aufgerufen, wenn der "Bearbeiten"-Button geklickt wird
  const handleEdit = (club) => {
    setEditingClub(club);
    setName(club.name);
    setContactPerson(club.contactPerson || '');
    setEmail(club.email || '');
    setPhone(club.phone || '');
  };

  // Wird aufgerufen, wenn der "Löschen"-Button geklickt wird
  const handleDelete = async (id) => {
    // Sicherheitsabfrage, um versehentliches Löschen zu verhindern
    if (window.confirm('Sind Sie sicher, dass Sie diesen Verein löschen möchten?')) {
      try {
        await apiClient.delete(`/api/clubs/${id}`); // GEÄNDERT: axios durch apiClient ersetzt
        fetchClubs(); // Liste neu laden
      } catch (err) {
        setError(err.response?.data?.message || 'Fehler beim Löschen.');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name) {
      setError('Ein Vereinsname ist erforderlich.');
      return;
    }

    const clubData = { name, contactPerson, email, phone };

    try {
      if (editingClub) {
        // ----- UPDATE-LOGIK -----
        await apiClient.put(`/api/clubs/${editingClub._id}`, clubData); // GEÄNDERT: axios durch apiClient ersetzt
      } else {
        // ----- CREATE-LOGIK -----
        await apiClient.post('/api/clubs', clubData); // GEÄNDERT: axios durch apiClient ersetzt
      }
      resetForm();
      fetchClubs();
    } catch (err) {
      setError(err.response?.data?.message || 'Ein Fehler ist aufgetreten.');
    }
  };

  return (
    <div className="screen-container">
      <h2>Vereinsverwaltung</h2>
      
      <div className="form-container">
        <h3>{editingClub ? 'Verein bearbeiten' : 'Neuen Verein anlegen'}</h3>
        <form onSubmit={handleSubmit}>
          {error && <p className="error-message">{error}</p>}
          <div className="form-group">
            <label>Vereinsname*</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Ansprechperson</label>
            <input type="text" value={contactPerson} onChange={(e) => setContactPerson(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Telefon</label>
            <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} />
          </div>
          <div className="form-buttons">
            <button type="submit">{editingClub ? 'Änderungen speichern' : 'Verein speichern'}</button>
            {editingClub && (
              <button type="button" className="btn-cancel" onClick={resetForm}>
                Abbrechen
              </button>
            )}
          </div>
        </form>
      </div>
      
      <hr />
      
      {/* Übergabe der neuen Handler-Funktionen an die ClubList */}
      <ClubList clubs={clubs} onEdit={handleEdit} onDelete={handleDelete} />
    </div>
  );
};

export default ClubScreen;